"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatJoiErrors = void 0;
function formatJoiErrors(validation) {
    return validation.error?.details.map(detail => detail.message);
}
exports.formatJoiErrors = formatJoiErrors;
